import { render, staticRenderFns } from "./CbsWidgetHabitTraining.vue?vue&type=template&id=c2720224&scoped=true"
import script from "./CbsWidgetHabitTraining.vue?vue&type=script&lang=js"
export * from "./CbsWidgetHabitTraining.vue?vue&type=script&lang=js"
import style0 from "./habits/habits.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CbsWidgetHabitTraining.vue?vue&type=style&index=1&id=c2720224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2720224",
  null
  
)

export default component.exports